export const siteContent = {
  brand: {
    name: "Magdump",
    kicker: "Precision Hardware",
    headline: "Hardware for control. Built to last.",
    intro:
      "Limited runs. First-drop hardware. Built for riders who notice the details.",
    primaryAction: "Join The Drop List",
    secondaryAction: "Event Details",
  },
  launchStats: [
    {
      value: "5-10",
      label: "deck shapes",
      detail: "First-run boards with dark grip, tight concave, and small-batch finishes.",
    },
    {
      value: "Drop 01",
      label: "boards + obstacles",
      detail: "A focused launch with decks, ledges, rails, and event-tied bundles.",
    },
    {
      value: "Drop list",
      label: "early access",
      detail: "Drop timing, event notes, and first purchase windows sent direct.",
    },
  ],
  launchStatus: {
    status: "coming_soon",
    message: "Drop 01 interest list is open",
  },
  shopPreview: [
    {
      title: "Fingerboard Designs",
      status: "First Run",
      description: "Small-batch maple decks with black grip, clean edge lines, and limited finish options.",
      visualAlt: "Premium black Magdump fingerboard product direction on a dark surface",
      demoSku: "MGD-DECK-001",
      demoPrice: "$34",
      demoAvailability: "Drop list open",
      demoSpec: "Maple deck",
    },
    {
      title: "Obstacles",
      status: "Core Line",
      description: "Street-scale rails and ledges made to sit beside the first board lineup.",
      visualAlt: "Close detail of fingerboard trucks, screws, bearings, and assembly tools",
      demoSku: "MGD-RAIL-002",
      demoPrice: "$28",
      demoAvailability: "Prototype run",
      demoSpec: "Rail and ledge kit",
    },
    {
      title: "Mystery Box",
      status: "Drop Concept",
      description: "A dark-pack bundle built around one board, one obstacle, and first-run extras.",
      visualAlt: "Dark event visual with fingerboard obstacles and metallic badge styling",
      demoSku: "MGD-BOX-003",
      demoPrice: "$59",
      demoAvailability: "Concept bundle",
      demoSpec: "Board plus obstacle",
    },
    {
      title: "Accessories",
      status: "Roadmap",
      description: "Soft goods, spare hardware, and carry pieces that extend the first drop language.",
      visualAlt: "Dark concrete and scratched metal texture for Magdump brand materials",
      demoSku: "MGD-GEAR-004",
      demoPrice: "$18+",
      demoAvailability: "Drop list open",
      demoSpec: "Soft goods",
    },
  ],
  event: {
    title: "Magdump Fingerboard Event",
    date: "Oct 17, 2026",
    dateStatus: "Doors at 6 PM",
    demoDateIso: "2026-10-17T18:00:00-04:00",
    venue: "Warehouse park venue",
    countdown: ["Days", "Hours", "Minutes"],
    copy:
      "An evening session for boards, rails, best-trick rounds, and a first look at Drop 01 hardware.",
    raffle:
      "Attendees enter a raffle draw for a board, obstacle, and hardware prize pack at the end of the night.",
    ticketIntent: "Event interest is open now. Ticket links unlock when capacity is confirmed.",
    schedule: [
      { time: "6:00 PM", title: "Doors and open park", detail: "Check-in, open table setups, and warm-up lines." },
      { time: "7:15 PM", title: "Best trick rounds", detail: "Timed heats across ledge, stair, and rail obstacles." },
      { time: "8:30 PM", title: "Raffle and Drop 01 table", detail: "Prize pack draw plus first look at Drop 01 boards." },
    ],
    ticketTiers: [
      { title: "General Pass", price: "$12", detail: "Entry, open park session, and raffle eligibility." },
      { title: "Rider Pass", price: "$18", detail: "Entry plus best-trick heat registration interest." },
      { title: "Drop Bundle Hold", price: "$45", detail: "Bundle interest for event-tied board and obstacle releases." },
    ],
    venueNote:
      "Address, capacity, waiver, and ticket link details are sent to the drop list before event night.",
  },
  journal: [
    {
      title: "Drop 01 materials",
      meta: "Hardware Notes",
      date: "May 2026",
      copy: "Dark grip, clean ply edges, and restrained metallic details define the first board family.",
      body:
        "The first board run is intentionally tight: compact shapes, durable finish language, and hardware that photographs well under low light. The goal is a drop that feels measured without losing the rough shop-floor edge.",
    },
    {
      title: "How the drop opens",
      meta: "Drop List",
      date: "First run",
      copy: "Subscribers hear first when boards, obstacles, and event passes are ready to move.",
      body:
        "The drop list carries the first purchase window, event ticket notes, and limited bundle timing. It keeps launch communication direct while the first confirmed product run comes together.",
    },
    {
      title: "Event as a hardware table",
      meta: "Community",
      date: "Oct 2026",
      copy: "The first event centers on riding, tuning, and getting the boards in hand.",
      body:
        "Expect open park time, best-trick heats, a raffle, and a close look at deck samples, rails, and parts. The night should feel like a table of hardware, not a banner ad.",
    },
  ],
  contact: {
    heading: "Get On The First Drop",
    copy:
      "Drop timing, board notes, event access, and collaboration messages all start here.",
    email: "launch@magdumpfb.com",
    signals: ["Drop list", "Event access", "Collab notes"],
  },
  footer: {
    summary:
      "Dark, hardware-forward fingerboard drops with boards, obstacles, event notes, and first-run updates in one place.",
    columns: [
      {
        title: "Explore",
        links: [
          { label: "Hardware", to: "/hardware" },
          { label: "Event", to: "/event" },
          { label: "Journal", to: "/journal" },
          { label: "Contact", to: "/contact" },
        ],
      },
      {
        title: "Launch State",
        links: [
          { label: "Drop list only", to: "/contact" },
          { label: "Event details", to: "/event" },
          { label: "Hardware lineup", to: "/hardware" },
        ],
      },
    ],
    legal: ["Drop 01", "Drop list open", "Purchasing opens with the first run"],
    status: "Drop list open",
  },
  commerce: {
    mode: "interest-list",
    liveCheckoutEnabled: false,
    futureIntegration: "checkout-provider",
    adapterBoundary: "src/integrations/commerce/",
  },
  demo: {
    mode: "drop-list-open",
    dataPolicy: "current-phase launch content with clear purchase boundaries",
    holdOffs: [
      "live-checkout",
      "inventory-fulfillment",
      "production-payment-processing",
      "order-admin-workflows",
    ],
    feedbackLane: {
      status: "release-copy-current",
      receipt: "content-resolution-matrix.json",
    },
  },
};
